import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

import api from "../services/api";
import Navbar from "../components/Navbar";
import { useAuth } from "../context/AuthContext";

function EditCategory() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { token } = useAuth();

  const [formData, setFormData] = useState({
    name: "",
    slug: "",
    description: ""
  });

  useEffect(() => {

    const loadCategory = async () => {

      try {

        const response = await api.get(
          `/categories/${id}`
        );

        const category = response.data;

        setFormData({
          name: category.name || "",
          slug: category.slug || "",
          description:
            category.description || ""
        });

      } catch (error) {

        console.error(error);

        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to load category"
        });

      }

    };

    loadCategory();

  }, [id]);

  const handleChange = (e) => {

    setFormData({
      ...formData,
      [e.target.name]:
        e.target.value
    });

  };

  const handleSubmit = async (e) => {

    e.preventDefault();

    try {

      await api.patch(
        `/categories/${id}`,
        formData,
        {
          headers: {
            Authorization:
              `Bearer ${token}`
          }
        }
      );

      await Swal.fire({
        icon: "success",
        title: "Success",
        text:
          "Category updated successfully!",
        timer: 2000,
        showConfirmButton: false
      });

      navigate("/categories/manage");

    } catch (error) {

      console.error(error);

      Swal.fire({
        icon: "error",
        title: "Update Failed",
        text:
          error.response?.data
            ?.message ||
          "Failed to update category"
      });

    }

  };

  return (
    <div>
      <Navbar />

      <div className="form-container">

        <h1>Edit Category</h1>

        <form onSubmit={handleSubmit}>

          <input
            type="text"
            name="name"
            placeholder="Category Name"
            value={formData.name}
            onChange={handleChange}
            required
          />

          <input
            type="text"
            name="slug"
            placeholder="Slug"
            value={formData.slug}
            onChange={handleChange}
            required
          />

          <textarea
            name="description"
            placeholder="Description"
            value={formData.description}
            onChange={handleChange}
          />

          <button type="submit">
            Update Category
          </button>

        </form>

      </div>
    </div>
  );
}

export default EditCategory;